import { useTranslation } from 'react-i18next';

import { Tooltip } from '../Tooltip';

import { MoonIcon, SunIcon } from './icons';
import { useTheme, type Theme } from './useTheme';

export function ThemeToggle(): JSX.Element {
  const { t } = useTranslation('common');
  const { theme, setTheme } = useTheme();
  const next: Theme = theme === 'light' ? 'dark' : theme === 'dark' ? 'system' : 'light';
  const label = t(`nav.theme_${theme}`);
  return (
    <Tooltip label={`${t('nav.toggle_theme')} · ${label}`}>
      <button
        type="button"
        onClick={() => setTheme(next)}
        aria-label={t('nav.toggle_theme')}
        data-testid="theme-toggle"
        data-theme={theme}
        className="inline-flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
      >
        {theme === 'dark' ? <MoonIcon size={18} /> : <SunIcon size={18} />}
      </button>
    </Tooltip>
  );
}
